export default "<p>\r\n  unautorized works!\r\n</p>\r\n";